import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Downicon from "../../../../assets/icons/bx-download.png";
import CarDetailSection from "../../../cars/components/cardetails/CarDetailSection";
import CarDetailFieldTable from "../../../cars/components/cardetails/CarDetailFieldTable";

function hasLeaseData(lease = {}) {
    const keys = [
        "startDate",
        "accountNo",
        "endDate",
        "payment",
        "milage",
        "agency",
        "duration",
        "waiver",
        "bankInfo",
        "contractDoc",
    ];
    return keys.some((key) => lease[key] != null && String(lease[key]).trim() !== "");
}

function StatusHeader({ contractDoc }) {
    const { t } = useTranslation("cars");
    const na = t("notAvailable");

    return (
        <div className="mb-4 flex items-center justify-between">
            {contractDoc ? (
                <div className="textBlue fontRegular text-sm">
                    <a href={contractDoc} className="underline">
                        {t("carDetail.viewDocument")}
                    </a>
                    &nbsp; <img src={Downicon} className="inline h-[0.8rem]" alt="" />
                </div>
            ) : (
                <span className="text-sm text-[#acacb9]">{na}</span>
            )}
        </div>
    );
}

StatusHeader.propTypes = {
    contractDoc: PropTypes.string,
};

function OwnstatCar({ data, loading = false }) {
    const { t } = useTranslation("cars");
    const na = t("notAvailable");
    const lease = data?.leaseData || {};

    const fields = [
        { label: t("carDetail.startDate"), value: lease.startDate },
        { label: t("carDetail.accountNumber"), value: lease.accountNo },
        { label: t("carDetail.endDate"), value: lease.endDate },
        { label: t("carDetail.payment"), value: lease.payment },
        { label: t("carDetail.mileageAllowance"), value: lease.milage },
        { label: t("carDetail.leasingAgency"), value: lease.agency },
        { label: t("carDetail.leaseDuration"), value: lease.duration },
        { label: t("carDetail.insuranceWaiver"), value: lease.waiver },
        { label: t("carDetail.bankInformation"), value: lease.bankInfo, span: 2 },
    ];

    const sectionTitle = data?.isOwned ? t("carDetail.owned") : t("carDetail.leased");
    const hasData = hasLeaseData(lease);

    return (
        <CarDetailSection
            loading={loading}
            embedded
            className="!mt-0"
            noPadding
            empty={!loading && !hasData}
            emptyDescription={t("carDetail.noOwnedLeasedInfo")}>
            <StatusHeader contractDoc={lease.contractDoc} />
            <CarDetailFieldTable title={sectionTitle} rows={fields} naFallback={na} column={1} />
        </CarDetailSection>
    );
}

OwnstatCar.propTypes = {
    data: PropTypes.shape({
        isOwned: PropTypes.bool,
        leaseData: PropTypes.shape({
            startDate: PropTypes.string,
            accountNo: PropTypes.string,
            endDate: PropTypes.string,
            payment: PropTypes.string,
            milage: PropTypes.string,
            agency: PropTypes.string,
            duration: PropTypes.string,
            waiver: PropTypes.string,
            bankInfo: PropTypes.string,
            contractDoc: PropTypes.string,
        }),
    }),
    loading: PropTypes.bool,
};

export default OwnstatCar;
